"use strict";

exports.__esModule = true;
exports.default = void 0;

var _TableContext = require("./internal/TableContext");

/**
 * A utility function to set selected row ids, based on the events produced by the
 * `onRowSelectionChange` callback. It operates on a given set of `selectedRowIds`,
 * adding/removing ids according to the particulars of the event.
 *
 * @param {object} selectionEvent         The event sent to the `onRowSelectionChange` function
 * @param {Array.<string>} selectedRowIds The current set of selected row ids
 * @param {Array.<string>} allIds         A list of all possible row ids
 * @return {Array.<string>}               The updated list of selected ids
 */
var _default = function _default(selectionEvent, selectedRowIds, allIds) {
  var rowIds;

  switch (selectionEvent.selectionType) {
    case _TableContext.TableProvider.ROW_SELECTION_ALL:
      rowIds = [].concat(allIds);
      break;

    case _TableContext.TableProvider.ROW_SELECTION_NONE:
      rowIds = [];
      break;

    case _TableContext.TableProvider.ROW_SELECTION_SELECTED:
      if (selectedRowIds.indexOf(selectionEvent.rowId) === -1) {
        rowIds = [].concat(selectedRowIds);
        rowIds.push(selectionEvent.rowId);
      }

      break;

    case _TableContext.TableProvider.ROW_SELECTION_UNSELECTED:
      var index = selectedRowIds.indexOf(selectionEvent.rowId);

      if (index !== -1) {
        rowIds = [].concat(selectedRowIds);
        rowIds.splice(index, 1);
      }

      break;

    default:
      console.warn("getSelectedRowIds: invalid selectionType: " + selectionEvent.selectionType);
      break;
  }

  return rowIds;
};

exports.default = _default;